import { AnalyticsConnector } from '@amplitude/analytics-connector';
import { normalizeInstanceName } from './utils/instance-name';
export var getAnalyticsConnector = function (instanceName) {
    return AnalyticsConnector.getInstance(normalizeInstanceName(instanceName));
};
export var setConnectorUserId = function (userId, instanceName) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    getAnalyticsConnector(instanceName).identityStore.editIdentity().setUserId(userId).commit();
};
export var setConnectorDeviceId = function (deviceId, instanceName) {
    getAnalyticsConnector(instanceName).identityStore.editIdentity().setDeviceId(deviceId).commit();
};
//# sourceMappingURL=analytics-connector.js.map